const zeroPad = (value: number): string => {
  return String(value).padStart(2, '0');
};

export default zeroPad;
